import React, { useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import PageWrapper from '../components/PageWrapper';

import catherineSmola1 from '../../assets/images/catherineSmola1.png';
import ScrollToTop from '../components/ScrollToTop';

const MessageFromPresident = (props) => {
  const { height, width, MAX_WIDTH, isMobile } = props;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // var isIE = /*@cc_on!@*/false || !!document.documentMode;
  // var isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && window['safari'].pushNotification));


  return (
    <PageWrapper height={height} showHeaderLogo maxWidth={MAX_WIDTH} isMobile={isMobile}>
      <Row style={{ marginTop: 120 }}>
        <Col>
          <Row>
            {!isMobile && width >= 576 && <Member/>}
            <Col xs={12} sm={8} md={8} lg={9} xl={9}>
              <Row>
                {!isMobile && width < 576 && <Member/>}
                <Col xs={7} sm={12}>
                  <h2
                    style={{ textAlign: 'left' }}
                    id="message-from-the-president"
                    tabIndex="-1"
                  >
                    {width < 576 ? 'mess- age' : 'message'} from {width < 576 ? 'PRES- IDENT' : 'president'}<br/>& CEO
          </h2>
                </Col>

              </Row>

              <div className="quoteSubheader" style={{ marginTop: 30 }}>
                “2020 was a testament to what can be achieved through innovation, collaboration and determination. If there was one thing to be certain of, it’s that teamwork and partnership are key to moving forward in challenging times.”
          </div>
              <p style={{ marginTop: 30 }}>
                It’s hard to believe over a year has gone by since the pandemic fundamentally shifted us to a virtual workforce. By now, we have all been impacted in some way or another. Despite the challenges we faced, 2020 was a testament to what can be achieved through innovation, collaboration and determination. If there was one thing to be certain of, it’s that teamwork and partnership are key to moving forward in challenging times.
                <br/><br/>It was through the spirit of continuous improvement and the commitment to industry excellence that CSIO was well positioned to serve our members. CSIO works to maintain and evolve data standards that meets the needs of the industry and inspire leading-edge solutions. Maintaining this foundation means being able to serve our members with solutions and services that are fresh, innovative, and advance the P&C insurance industry. In this report, we are pleased to highlight some of these achievements.          </p>
              <ul
                className="letterFromPresidentBullets"
                style={{
                  marginLeft: 0,
                  paddingLeft: 0,
                  listStylePosition: 'inside',
                }}>
                <li>
                  <span style={{ fontWeight: 'bold' }}>The Innovation and Emerging Technology (INNOTECH) Advisory Committee</span> and its Working Groups made tremendous progress. After the Committee reached consensus on three common industry pain points in March, the Working Groups quickly moved on to researching and securing three digital solutions that will improve operational efficiency and the customer experience. I’m pleased to say that by September, the Claims and Billing Working Groups announced they had chosen to leverage CSIOnet and the CSIO eDocs Standard for the billing and claims notification solutions. The third solution for API standardization is moving forward with advancing a security model and identifying the specifications required.
          </li>
                <li style={{ marginTop: 30 }}>
                  <span style={{ fontWeight: 'bold' }}>My Proof of Insurance (MPOI)</span> increased in adoption as in-person meetings and paper mail decreased during the pandemic, and CSIO supported its members as they went digital. Our MPOI solution allowed insurers and brokers to send clients their proof of auto insurance (eSlips) and important policy documents quickly, efficiently, and securely. We were pleased to see a 400% increase in eSlips and documents sent through the solution compared to 2019. This supports research indicating consumers want more digital, modern options for receiving their insurance documents.
          </li>
                <li style={{ marginTop: 30 }}>
                  <span style={{ fontWeight: 'bold' }}>The Commercial Lines Working Group</span> accomplished several achievements to further the implementation of Commercial Lines Data Standards. Questions were finalized for small retail and professional services in order to better underwrite and rate these two business segments. With small contractors completed in 2019, there are now three segments completed. CSIO also launched a Commercial Lines (CL) Data Standards Certification Program designed to support and recognize members who have implemented CSIO CL Data Standards according to industry best practices. Launched in April, there has already been significant industry adoption with six members certified. According to a recent member survey, 90% of members reported CL Data Standards as being very important/important for the industry, and as such their implementation will continue to be a priority for CSIO in 2021.
          </li>
                <li style={{ marginTop: 30 }}>
                  <span style={{ fontWeight: 'bold' }}>The Digital eLearning Program</span> expanded in many ways to meet the growing demand for online and on-demand learning. CSIO launched 12 new courses, bringing the total to 15 courses available at no cost to members. Insurers, brokers, and vendors alike have completed courses on valuable skills regarding cybersecurity, digital marketing, and insurance technology tools. Several members have completed six or more of the accredited courses, earning a Digital Member certificate and demonstrating their commitment to continuing education.
          </li>
              </ul>
              <p>
                As we look ahead to another year of adjusting and adapting to this new normal, I am confident that the industry collaboration we saw in 2020 will serve us well as we keep innovating and finding more efficient ways to deliver digital experiences. The CSIO team looks forward to continuing to support our members with advancing the digitization of the industry.
        </p>
              <p style={{ marginTop: 30 }}>
                Sincerely,<br /><br />Catherine Smola<br />CSIO<br />President & CEO
        </p>
            </Col>
          </Row>
        </Col>
      </Row>
      <ScrollToTop height={height} width={width} maxWidth={MAX_WIDTH}/>
    </PageWrapper>
  )
}

export default MessageFromPresident;

const Member = ({ style }) => (
  <Col xs={5} sm={4} md={4} 
  lg={3} xl={3} style={{
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    marginBottom: 25,
    ...style
  }}>
    <img
      src={catherineSmola1}
      style={{
        width: '100%',
        height: 'auto',
        marginLeft: 40,
        marginRight: 40,
      }}
      aria-label="Picture of Catherine Smola"
    />
    <div className="homepageExecName">
      CATHERINE SMOLA
          </div>
          <div className="homepageExecTitle">
      CSIO President<br/>& CEO
          </div>
  </Col>
);
